import { type GranularityType } from "@tokenterminal/ui/Chart/Chart"

export type { GranularityType as GranularityValues } from "@tokenterminal/ui/Chart/Chart"

type Option<T extends any> = {
  value: T
  label: string
  disabled?: boolean
}

export type GranularityOption = Option<GranularityType>

export const GRANULARITIES: Array<GranularityOption> = [
  {
    value: "day",
    label: "D",
  },
  {
    value: "week",
    label: "W",
  },
  {
    value: "month",
    label: "M",
  },
  {
    value: "quarter",
    label: "Q",
  },
]
